import api from './api';
import { ApiResponse } from '../types';

export interface CrisisAlert {
  studentId: number;
  studentName: string;
  idCardNumber: string;
  studentNumber: string | null;
  schoolName: string | null;
  className: string | null;
  grade: string | null;
  academicYear: string | null;
  questionnaireId: number;
  questionnaireCode: string | null;
  questionnaireTitle: string;
  indicatorName: string;
  score: number;
  conclusionTitle: string;
  calculatedAt: string;
}

export interface WeekData {
  weekLabel: string;
  weekStart: string;
  counts: Record<string, number>;
}

export interface CrisisWeeklyTrend {
  indicators: string[];
  weeks: WeekData[];
}

export const crisisService = {
  /** 预警列表 — 传 questionnaireId 按问卷过滤；不传返回全部（兼容旧调用） */
  getAllAlerts: async (questionnaireId?: number): Promise<CrisisAlert[]> => {
    const params: Record<string, any> = {};
    if (questionnaireId != null) params.questionnaireId = questionnaireId;
    const response = await api.get<ApiResponse<CrisisAlert[]>>('/admin/crisis-alerts', { params });
    return response.data.data;
  },

  /** 周趋势 — 传 questionnaireId 按问卷过滤 */
  getWeeklyTrend: async (weeks: number = 8, questionnaireId?: number): Promise<CrisisWeeklyTrend> => {
    const params: Record<string, any> = { weeks };
    if (questionnaireId != null) params.questionnaireId = questionnaireId;
    const response = await api.get<ApiResponse<CrisisWeeklyTrend>>('/admin/crisis-alerts/weekly-trend', { params });
    return response.data.data;
  },
};
